import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const NewsDetailSecondaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const NewsDetailActionLink = styled.a.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const NewsDetailGridLayout = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

export const NewsDetailContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const NewsDetailHeroImage = styled(FallbackImage).attrs({
  className: "h-80 w-full rounded-[24px]",
})``;

export const NewsDetailGridLayoutSecondary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const NewsDetailSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const NewsDetailEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const NewsDetailTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const NewsDetailBodyText = styled.p.attrs({
  className: "mt-3 whitespace-pre-wrap text-sm leading-7 text-[var(--brand-ink)]",
})``;

